import React from 'react';
import MyAccountCard from './MyAccountCard';
import * as Row from '../layout/Row';

export default class MyAccountPasswordCard extends MyAccountCard {
    title = __('Change password')
    endpoint = 'ChangePassword'

    state = {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: ''
    }

    renderBody() {
        return (
            <Row.Container hasOuterGutter={false}>
                <div className="column-6 column-xs-12">
                    {this.renderPasswordField(__('Current password'), this.state.currentPassword, newValue => this.setState({currentPassword: newValue}))}
                    {this.renderPasswordField(__('New password'), this.state.newPassword, newValue => this.setState({newPassword: newValue}))}
                    {this.renderPasswordField(__('Repeat new password'), this.state.newPasswordConfirm, newValue => this.setState({newPasswordConfirm: newValue}))}
                </div>
            </Row.Container>
        )
    }

    getModel() {
        return {
            OldPassword: this.state.currentPassword,
            NewPassword: this.state.newPassword,
            ConfirmNewPassword: this.state.newPasswordConfirm
        }
    }
}
